<script setup>
import { computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Auth from 'dashboard/api/auth';
import AccountAPI from 'dashboard/api/account';
import { frontendURL } from 'dashboard/helper/URLHelper';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const accountId = computed(() => route.params.accountId);

const handleLogout = () => {
  Auth.logout();
};

const goHome = () => {
  window.location.assign('/app/');
};

// If access is allowed again, leave this error page.
onMounted(async () => {
  try {
    await AccountAPI.get();
    router.replace(frontendURL(`accounts/${accountId.value}/copilot`));
  } catch {
    // Stay when the account API still denies this IP.
  }
});
</script>

<template>
  <div
    class="flex flex-col flex-1 items-center justify-center w-full h-full gap-6 bg-n-slate-2"
  >
    <EmptyState
      :title="t('APP_GLOBAL.ACCOUNT_ACCESS_LOCKED.TITLE')"
      :message="t('APP_GLOBAL.ACCOUNT_ACCESS_LOCKED.MESSAGE')"
    />
    <div class="flex flex-wrap items-center justify-center gap-3">
      <NextButton
        variant="smooth"
        color-scheme="secondary"
        :label="t('APP_GLOBAL.ACCOUNT_ACCESS_LOCKED.SWITCH_ACCOUNT')"
        @click="goHome"
      />
      <NextButton
        variant="solid"
        color-scheme="primary"
        :label="t('APP_GLOBAL.ACCOUNT_ACCESS_LOCKED.LOGOUT')"
        @click="handleLogout"
      />
    </div>
  </div>
</template>
